'use client';

import {
	Description,
	Dialog,
	DialogBackdrop,
	DialogPanel,
	DialogTitle,
} from '@headlessui/react';

import { Button, WarningCircleIcon } from '@/shared';

import { ConfirmOptions } from '../config';

type ConfirmProps = {
	open: boolean;
	onClose: () => void;
	onConfirm: () => void;
	options?: ConfirmOptions;
};

export const Confirm = ({
	open,
	onClose,
	onConfirm,
	options,
}: ConfirmProps) => {
	return (
		<Dialog
			open={open}
			onClose={() => null}
			transition
			className="data-closed:opacity-0 relative z-50 transition duration-300 ease-out"
		>
			<DialogBackdrop
				transition
				className="data-closed:opacity-0 fixed inset-0 bg-gray-1/60 backdrop-blur-[1px] duration-300 ease-out"
			/>
			<div className="fixed inset-0 flex w-screen items-end justify-center sm:items-center sm:p-4">
				<DialogPanel
					transition
					className="bg-white-main data-closed:scale-95 data-closed:opacity-0 relative w-full bg-white duration-300 ease-out sm:max-w-[600px] sm:rounded-lg sm:rounded-t-lg sm:border sm:border-gray-4"
				>
					<div className="mx-auto flex flex-col items-center gap-y-12 px-4 py-12 sm:px-20 sm:py-20">
						<div className="rounded-full bg-[#FFF5DD] p-6">
							<WarningCircleIcon className="size-8 text-yellow" />
						</div>
						<div className="space-y-2 text-center">
							<DialogTitle className="text-xl font-semibold">
								{options?.title || 'Подтверждение'}
							</DialogTitle>
							<Description className="text-sm">
								{options?.description || ''}
							</Description>
						</div>
						<div className="mx-auto space-y-4">
							<Button onClick={onConfirm} className="w-full">
								{options?.confirmText ?? 'Подтвердить'}
							</Button>
							<Button onClick={onClose} variant="outline" className="w-full">
								{options?.cancelText ?? 'Отмена'}
							</Button>
						</div>
					</div>
				</DialogPanel>
			</div>
		</Dialog>
	);
};
